import { Component, OnInit,Input, Output,EventEmitter } from '@angular/core';
import { CurrencyService } from '../../../../services/currency.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CompararService } from '../../../../services/general/comparar.service';
import { Subscription } from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';


@Component({
  selector: 'app-modal-comparar',
  templateUrl: './comparar.component.html',
  styleUrls: ['./comparar.component.css'],
  providers: [CompararService]

})
export class CompararComponent implements OnInit {

  @Input('polizas') polizasComparar;
  @Input('beneficios') beneficios;


  // Usamos el decorador Output
    @Output() comprarPoliza = new EventEmitter();
    constructor(public _currencyService:CurrencyService,private route: ActivatedRoute,private router: Router) { }

    ngOnInit() {
    }
    obtenerValorCobertura(beneficio,poliza){
        var valor="-";
        try{
            valor=poliza.coberturasCompletas.filter( o => o.descripcion === beneficio.descripcion)[0].precio;
        }
        catch(error){}
        return valor;
    }
    // evento que usa el evenemitter para lanzar el eventemitter  y disparar la compra
    clickBotonCompra(event,p){
                // Usamos el m�todo emit
        this.comprarPoliza.emit({poliza: p});
    }


    conversionMonedas(indice:String) {
      let coleccion = this.polizasComparar[0].conversionMoneda;
      let item = coleccion.filter(x => x.id == indice);
      this._currencyService.setValor(item.valor);
      return item.valor;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/general/modals/comparar/comparar.component.ts